export enum KlarnaCheckoutApiEventName {
  onLoaded = 'load',
  onUserInteracted = 'user_interacted',
  onCustomer = 'customer',
  onChange = 'change',
  onBillingAddressChange = 'billing_address_change',
  onShippingAddressChange = 'shipping_address_change',
  onShippingMethodChange = 'shipping_option_change',
  onShippingAddressUpdateError = 'shipping_address_update_error',
  onOrderTotalChange = 'order_total_change',
  onCheckboxChange = 'checkbox_change',
  onCanNotCompleteOrder = 'can_not_complete_order',
  onNetworkError = 'network_error',
  onRedirectInitiated = 'redirect_initiated',
  onLoadConfirmation = 'load_confirmation',
  onValidationCallback = 'validation_callback',
}

export interface KlarnaCheckoutApiEventPayload {
  [KlarnaCheckoutApiEventName.onLoaded]: KlarnaLoadedEvent;
  [KlarnaCheckoutApiEventName.onUserInteracted]: Interaction;
  [KlarnaCheckoutApiEventName.onCustomer]: Customer;
  [KlarnaCheckoutApiEventName.onChange]: AddressType;
  [KlarnaCheckoutApiEventName.onBillingAddressChange]: AddressType;
  [KlarnaCheckoutApiEventName.onShippingAddressChange]: AddressType;
  [KlarnaCheckoutApiEventName.onShippingMethodChange]: ShippingOptionType;
  [KlarnaCheckoutApiEventName.onShippingAddressUpdateError]: Record<string, never>;
  [KlarnaCheckoutApiEventName.onOrderTotalChange]: OrderTotal;
  [KlarnaCheckoutApiEventName.onCheckboxChange]: CheckboxChange;
  [KlarnaCheckoutApiEventName.onCanNotCompleteOrder]: Record<string, never>;
  [KlarnaCheckoutApiEventName.onNetworkError]: Record<string, never>;
  [KlarnaCheckoutApiEventName.onRedirectInitiated]: true;
  [KlarnaCheckoutApiEventName.onLoadConfirmation]: Record<string, never>;
  [KlarnaCheckoutApiEventName.onValidationCallback]: Record<string, never>;
}

export type Interaction = {
  type: 'mousedown' | 'keydown';
};

export type Customer = {
  type: 'person' | 'organization';
};

export type KlarnaLoadedEvent = {
  customer: Customer;
  shipping_address: AddressType;
};

export type ShippingOptionType = {
  description: string;
  id: string;
  name: string;
  price: number;
  promo: string;
  tax_amount: number;
  tax_rate: number;
};

export type AddressType = {
  email?: string;
  postal_code: string;
  country: string;
  given_name?: string;
  family_name?: string;
};

export type OrderTotal = {
  order_total: number;
};

export type CheckboxChange = {
  key: string;
  checked: boolean;
};

export type CountryChangeType = {
  country?: string;
};
